document.addEventListener('DOMContentLoaded', function () {

  /* Sticky header solidify on scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var solidify = function () {
      if (window.scrollY > 40) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
    };
    solidify();
    window.addEventListener('scroll', solidify, { passive: true });
  }

  /* Mobile menu toggle */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-item__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-item__a');
      var isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq-item__a').style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-gallery]');
      var mainImg = gallery.querySelector('[data-gallery-main]');
      if (mainImg && thumb.dataset.fullSrc) {
        mainImg.src = thumb.dataset.fullSrc;
      }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* Quantity selectors */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(input.step || '1', 10);
        var val = parseInt(input.value || '1', 10);
        var min = parseInt(input.min || '1', 10);
        if (btn.dataset.action === 'increase') {
          input.value = val + step;
        } else {
          input.value = Math.max(min, val - step);
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.closest('.product__info').querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var optionWraps = form.querySelectorAll('[data-option-selector]');
    var idInput = form.querySelector('[data-product-variant-id]');
    var priceEl = document.getElementById('ProductPrice');
    var buyBtn = form.querySelector('[data-add-to-cart]');
    var mainImg = document.getElementById('ProductMainImage');

    function currentSelection() {
      var selected = [];
      optionWraps.forEach(function (wrap) {
        var active = wrap.querySelector('.swatch.is-active');
        selected.push(active ? active.dataset.optionValue : null);
      });
      return selected;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selection.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2);
    }

    function updateUI() {
      var variant = findVariant(currentSelection());
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
        }
        html += formatMoney(variant.price);
        priceEl.innerHTML = html;
      }

      if (buyBtn) {
        if (!variant.available) {
          buyBtn.setAttribute('disabled', 'disabled');
          buyBtn.textContent = buyBtn.dataset.labelSoldOut || 'Sold out';
        } else {
          buyBtn.removeAttribute('disabled');
          buyBtn.textContent = buyBtn.dataset.labelAdd || 'Add to cart';
        }
      }

      if (mainImg && variant.featured_image && variant.featured_image.src) {
        mainImg.src = variant.featured_image.src;
      }
    }

    optionWraps.forEach(function (wrap) {
      wrap.querySelectorAll('.swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updateUI();
        });
      });
    });
  });

  /* AJAX add to cart */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var formData = new FormData(form);

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.textContent;
        submitBtn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showCartNotification();
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText;
          }
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function showCartNotification() {
    var notif = document.getElementById('cart-notification');
    if (!notif) return;
    var msg = notif.querySelector('.cart-notification__message');
    if (msg) msg.textContent = 'Added to your cart';
    notif.classList.add('is-visible');
    clearTimeout(window._cartNotifTimeout);
    window._cartNotifTimeout = setTimeout(function () {
      notif.classList.remove('is-visible');
    }, 3500);
  }

  /* Newsletter form (theme editor / storefront friendly, Shopify handles submit natively) */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var success = form.querySelector('.newsletter__success');
      if (success) success.style.display = 'block';
    });
  });

  /* Cart line quantity change -> update via /cart/change.js */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.line;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: input.value })
      }).then(function () {
        window.location.reload();
      });
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.dataset.line;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () {
        window.location.reload();
      });
    });
  });
});
